import { render, staticRenderFns } from "./rezervasyonlistesi.vue?vue&type=template&id=4535e1d8&"
import script from "./rezervasyonlistesi.vue?vue&type=script&lang=js&"
export * from "./rezervasyonlistesi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports